import { typedObjectKeys } from "../../utils/index.js";
import { createAppSessionEventDefinition } from "../AppSessionEventDefinition.js";

export const CLEAR_ALL_OUTPUTS = createAppSessionEventDefinition({
  type: "CLEAR_ALL_OUTPUTS",
  logSafe: {},
  create: () => ({}),
  apply: ({ indices, state }) => {
    state.outputs = {};
    state.outputContents = {};

    for (const appSessionCellId of typedObjectKeys(
      indices.appSessionCellIdToOutputIds,
    )) {
      indices.appSessionCellIdToOutputIds[appSessionCellId] = [];
    }
    indices.outputIdToOutputContentIds = {};
  },
});
